import { Action } from '@agile-actors/actions/js';

import { openSnackbar } from 'components/layout/components/snackbar/ui-model';

const namespaceAction = Action('@@router');
const locationChange = namespaceAction('LOCATION_CHANGE');

export { openSnackbar, locationChange };
